import { useEffect } from 'react';
import { useCoaStore } from '../stores/coa-store';
import { CoaNode, ActionMode } from '../types';
import {
    useCoasSettings,
    useCreateCoa,
    useUpdateCoa,
    useDeleteCoa
} from "@/shared/api/client/coa-resource";
import { CoaDTO } from '@/shared/api/model';

export const useCoa = () => {
    const store = useCoaStore();

    // Queries - now using settings endpoint
    const {
        data: coaResponse,
        isLoading,
        error,
        refetch
    } = useCoasSettings({
        query: {
            enabled: true,
        }
    });

    // Mutations
    const createMutation = useCreateCoa();
    const updateMutation = useUpdateCoa();
    const deleteMutation = useDeleteCoa();

    // Update store when data changes
    useEffect(() => {
        if (coaResponse) {
            store.setRawData(coaResponse);
        }
    }, [coaResponse]);

    // Common handling for modal actions
    const handleNodeAction = (node: CoaNode, mode: ActionMode) => {
        store.setActiveNode(node);
        store.setActionMode(mode);
        store.setModalOpen(true);
    };

    // CRUD operations with refetch
    const createCoa = async (data: CoaDTO) => {
        await createMutation.mutateAsync({ data });
        refetch();
    };

    const updateCoa = async (data: CoaDTO) => {
        await updateMutation.mutateAsync({ data });
        refetch();
    };

    const deleteCoa = async (glNo: string) => {
        await deleteMutation.mutateAsync({ glNo });
        refetch();
    };

    return {
        // State
        treeData: store.treeData,
        rawData: store.rawData,
        activeNode: store.activeNode,
        actionMode: store.actionMode,
        isModalOpen: store.isModalOpen,
        expandedKeys: store.expandedKeys,
        isLoading,
        error,

        // Actions
        setActiveNode: store.setActiveNode,
        setActionMode: store.setActionMode,
        setModalOpen: store.setModalOpen,
        toggleExpanded: store.toggleExpanded,
        setExpandedKeys: store.setExpandedKeys,
        handleNodeAction,

        // CRUD operations
        createCoa,
        updateCoa,
        deleteCoa,
        refetch,
    };
};